module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lHK1n"))).then(() => parcelRequire('cvs7o'));